import type { ComponentType, SVGProps } from 'react'
import type { SsoProviderKey } from '@/lib/auth/ssoProviders'
import { AppleLogo } from './AppleLogo'
import { GoogleGLogo } from './GoogleGLogo'

type LogoComponent = ComponentType<SVGProps<SVGSVGElement> & { size?: number }>

const SSO_PROVIDER_LOGOS: Record<SsoProviderKey, LogoComponent> = {
    google: GoogleGLogo,
    apple: AppleLogo,
}

/** Brand mark for a social sign-in provider. */
export function SsoProviderIcon({
    provider,
    size = 20,
}: {
    provider: SsoProviderKey
    size?: number
}) {
    const Logo = SSO_PROVIDER_LOGOS[provider]
    return <Logo size={size} />
}
